import axios from "axios";
import { SERVER_URL } from "../config";

export const fetchDashboardData = async () => {
  try {
    const res = await axios.get(`${SERVER_URL}dashboard.php`);
    return res.data;
  } catch (error) {
    console.error("Error fetching dashboard data:", error);
    throw error;
  }
};